import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'utils/isNil';
import styled from 'styled-components';
import Collapse from 'rc-collapse';
import useIsColorDark from 'hooks/useIsColorDark';
import 'rc-collapse/assets/index.css';
import Text from 'components/Core/Text';

var Panel = Collapse.Panel;
const FAQPanel = ({ header, children, ...otherProps }) => (
  <Panel forceRender header={<h3>{header}</h3>} {...otherProps}>
    {children}
  </Panel>
);

const ContentfulAccordion = ({
  accordionBgColor,
  backgroundColor,
  border,
  heading,
  subhead,
  components,
  ...otherProps
}) => {
  const background = backgroundColor?.backgroundColor;

  return (
    <SectionFaq
      background={background}
      accordionBgColor={accordionBgColor}
      border={border}
      id="websiteAccordion"
      {...otherProps}
    >
      <div className="section-faq--container">
        {heading && (
          <Text type="p" size="h2" className="section-faq--title">
            {heading}
          </Text>
        )}
        {subhead?.subhead && <p className="section-faq--subhead">{subhead.subhead}</p>}
        <div className="section-faq--faq-container">
          <Collapse accordion={false}>
            {!isNil(components) &&
              components.map((faqItem, index) => {
                if (index < 4) {
                  return (
                    !isNil(faqItem.question && faqItem.answer) && (
                      <FAQPanel header={faqItem.question.question} key={index}>
                        {faqItem.answer.hasOwnProperty('childMarkdownRemark') ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: faqItem.answer.childMarkdownRemark.html,
                            }}
                          />
                        ) : (
                          faqItem.answer.answer
                        )}
                      </FAQPanel>
                    )
                  );
                } else if (index == 4) {
                  return (
                    !isNil(faqItem.question && faqItem.answer) && (
                      <FAQPanel header={faqItem.question.question} key={index}>
                        {faqItem.answer.hasOwnProperty('childMarkdownRemark') ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: faqItem.answer.childMarkdownRemark.html,
                            }}
                          />
                        ) : (
                          faqItem.answer.answer
                        )}
                      </FAQPanel>
                    )
                  );
                } else {
                  return (
                    !isNil(faqItem.question && faqItem.answer) && (
                      <FAQPanel
                        className="mobile-view"
                        header={faqItem.question.question}
                        key={index}
                      >
                        {faqItem.answer.hasOwnProperty('childMarkdownRemark') ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: faqItem.answer.childMarkdownRemark.html,
                            }}
                          />
                        ) : (
                          faqItem.answer.answer
                        )}
                      </FAQPanel>
                    )
                  );
                }
              })}
          </Collapse>
        </div>
      </div>
    </SectionFaq>
  );
};

ContentfulAccordion.defaultProps = {
  border: true,
};

ContentfulAccordion.propTypes = {
  background: PropTypes.object,
  title: PropTypes.string,
  subhead: PropTypes.object,
  components: PropTypes.array,
};

export default ContentfulAccordion;

const SectionFaq = styled.div`
  background: ${props => props.background};
  .section-faq--container {
    padding: 80px 28px;
    max-width: 840px;
    margin: 0 auto;
    .section-faq--title {
      font-size: 49px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: ${props => {
        return props.accordionBgColor
          ? useIsColorDark(props.accordionBgColor) && 'var(--white-color)'
          : 'var(--normal-title-color)';
      }};
    }
    .section-faq--subhead {
      font-size: 20px;
      line-height: 150%;
      text-align: center;
      color: var(--normal-description-color);
    }
    .section-faq--faq-container {
      margin-top: 47px;
    }
    .section-faq--view-more {
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: #9b9ea8;
      cursor: pointer;
      display: none;
    }
  }
  @media (max-width: 768px) {
    .section-faq--container {
      padding: 48px 28px;
      max-width: 524px;
      .section-faq--title {
        font-size: 29px;
        letter-spacing: -0.03em;
      }
      .section-faq--subhead {
        font-size: 18px;
        line-height: 28px;
        margin-top: 22px;
        padding: 0 10px;
      }
      .section-faq--subhead {
        font-size: 20px;
        line-height: 150%;
        text-align: center;
        color: var(--normal-description-color);
      }
      .section-faq--faq-container {
        margin-top: 40px;
      }
    }
  }
  @media (max-width: 576px) {
    .section-faq--container {
      padding: 48px 20px;
      max-width: 100%;
      .section-faq--view-more {
        display: block;
      }
    }
  }
  .rc-collapse {
    background: none;
    border-radius: 0;
    border: none;
    font-family: Sofia Pro;
    & > .rc-collapse-item {
      border: ${props => (props.border ? '1px solid var(--neutral-2)' : 'none')};
      box-sizing: border-box;
      background: ${props => props.accordionBgColor};
      margin-bottom: 24px;
      &:first-child {
        border-top: ${props => (props.border ? '1px solid var(--neutral-2)' : 'none')};
      }
      & > .rc-collapse-header {
        outline: none;
        padding: 28px 78px 28px 32px;
        position: relative;
        h3 {
          font-size: 20px;
          font-weight: bold;
          line-height: 120%;
          color: ${props => {
            return props.accordionBgColor
              ? useIsColorDark(props.accordionBgColor) && 'var(--white-color)'
              : 'var(--normal-title-color)';
          }};
          margin: 0;
        }
        .arrow {
          position: absolute;
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 8px solid var(--blue-5);
          right: 40px;
          margin-right: 0;
          top: auto;
        }
      }
      .rc-collapse-content {
        padding: 13px 32px 0;
        max-width: 713px;
        background: ${props => props.accordionBgColor};
        & > .rc-collapse-content-box {
          p {
            color: var(--normal-description-color);
            white-space: pre-wrap;
            font-weight: 500;
            font-size: 20px;
            line-height: 150%;
          }
          margin: 0;
          padding-bottom: 32px;
        }
      }
    }
    & > .rc-collapse-item-active {
      & > .rc-collapse-header {
        .arrow {
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 7px solid transparent;
          border-bottom: 8px solid var(--blue-5);
          margin-top: -7px;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .rc-collapse {
      & > .rc-collapse-item {
        margin-bottom: 16px;
        & > .rc-collapse-header {
          padding: 24px 61px 24px 24px;
          h3 {
            font-size: 18px;
          }
          .arrow {
            right: 16px;
          }
        }
        .rc-collapse-content {
          padding: 4px 24px 0;
          max-width: 431px;
          & > .rc-collapse-content-box 
            p {
              font-size: 17px;
            }
            padding-bottom: 24px;
          }
        }
      }
    }
  }
  @media (max-width: 576px) {
    .rc-collapse {
      & > .rc-collapse-item {
        &.mobile-view {
          display: none;
        }
      }
    }
  }
  .section-faq--faq-container.show-all-faq {
    .section-faq--view-more {
      display: none;
    }
    .mobile-view {
      display: block;
    }
  }
`;
